// extracted by mini-css-extract-plugin
export default {"header":"HLsPk","textContainer":"GkP5a","title":"deSqD","text":"aoLFU","button":"lR3ib","firstPart":"crY3F"};